import moment from 'moment';

export const getDayString = myDate => {
  const dayName = moment(myDate).calendar(null, {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]'
  });
  return dayName === 'Yesterday' || dayName === 'Today' || dayName === 'Tomorrow'
    ? dayName
    : moment(myDate).format('MMMM D');
};
